<panel width="900">
	<h1>{{ 'product-plan-search.header' | translate }}</h1>
	<section>
		<div><date-input [label]="'product-plan-search.renewal-date-from' | translate" [(value)]="renewalDateFrom" [maxDate]="renewalDateTo" /></div>
		<div><date-input [label]="'product-plan-search.renewal-date-to' | translate" [(value)]="renewalDateTo" [minDate]="renewalDateFrom" /></div>
		<tags [(selectedTags)]="tags" [tags]="tagsOnProductPlans" />
		<div><custom-input inputType="switch" [label]="'product-plan-search.only-delivered-plans' | translate" [(value)]="onlyDeliveredPlans" /></div>
		<div><custom-input inputType="switch" [label]="'product-plan-search.only-terminated-plans' | translate" [(value)]="onlyTerminatedPlans" /></div>
	</section>
	<section>
		<button confirm #searchButton (click)="searchProductPlans()" [label]="'product-plan-search.search' | translate" [active]="productPlans && renewalDateFrom && renewalDateTo && renewalDateTo > renewalDateFrom"></button>
	</section>
	@if (productPlans) {
		<list-view scrollable>
			<header>{{ 'general.column.company-name' | translate }}</header>
			<header>{{ 'company.product-plans.product-name' | translate }}</header>
			<header>{{ 'product-plan.delivery-date' | translate }}</header>
			<header defaultSort="ascending">{{ 'product-plan.date-for-renewal' | translate }}</header>
			<header align-right>{{ 'company.product-plans.auto-renewal.yearly-value' | translate }}</header>
			<row data-id="{{ plan.id }}" *listData="let plan from productPlans" (action)="selectProductPlan(plan)"
				 [statusColor]="plan.terminationDate ? 'color-red-50' : undefined"
				 [statusTitle]="plan.terminationDate ? ('product-plan.terminated.date' | translate: { terminationDate: (plan.terminationDate | customDate: 'shortDate') }) : undefined">
				<column>{{ plan.company?.name }}</column>
				<column>{{ plan | productName }}</column>
				<column [sortValue]="plan.deliveryDate">{{ plan.deliveryDate | customDate: 'shortDate' }}</column>
				<column [sortValue]="plan.autoRenewalDate">{{ plan.autoRenewalDate | customDate: 'shortDate' }}</column>
				<column [sortValue]="plan.annualValueForRenewal" align-right>{{ plan.annualValueForRenewal | currency }}</column>
			</row>
		</list-view>
	}
	@else {
		<skeletons [defaultSkeletons]="4" />
	}
</panel>
